import React, {useState} from 'react';
import PropTypes from 'prop-types';

function NumberField({
    id,
    label,
    required,
    defaultValue,
    disabled,
    size,
    min,
    max,
    onChange}) {
    const [fieldId] = useState(id ? id : 'numberfield-' + Math.floor(Math.random() * 99999));

    const entryClasses = ['form__entry'];
    if (required) {
        entryClasses.push('form__entry--required');
    }
    if (size) {
        entryClasses.push('form__entry--size-' + size);
    }

    return (
        <div className={entryClasses.join(' ')}>
            <div className='form__label'>
                <label htmlFor={fieldId}>
                    <span className='form__label__text'>
                        {label}
                    </span>
                </label>
            </div>
            <div className='form__field'>
                <input
                    id={fieldId}
                    name={fieldId}
                    className='form__input'
                    defaultValue={defaultValue}
                    onChange={onChange}
                    min={min}
                    max={max}
                    type='number'
                    required={required}
                    disabled={disabled === true}
                />
            </div>
        </div>
    );
}

NumberField.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    id: PropTypes.string,
    required: PropTypes.bool,
    defaultValue: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['l', 's']),
};


export default NumberField;
